/* eslint-disable react/jsx-key */
import React, { Component } from "react"
import CashboxComponent from "../components/CashboxComponent"
import PaymentComponent from "../components/PaymentComponent"
import { withRouter } from "react-router-dom"
import { Modal, Button, Card, Loader } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import {
  getGroups,
  getTariffs,
  getAllTariffs,
  payTariff,
} from "../ducks/payment"
import { connect } from "react-redux"

const data = [
  /* {
    name: "CashName1",
    physicalization: true,
    endDate: "2020-01-15",
    months: 3,
    smartkassa_cost: 3400,
    web_kassa_cost: 1400,
  },
  {
    name: "CashName2",
    physicalization: false,
    endDate: "2020-01-25",
    months: 2,
    smartkassa_cost: 2700,
    web_kassa_cost: 800,
  },
  {
    name: "CashName3",
    physicalization: true,
    endDate: "2020-02-17",
    months: 3,
    smartkassa_cost: 4200,
    web_kassa_cost: 1600,
  },
  {
    name: "CashName4",
    physicalization: false,
    endDate: "2020-03-01",
    months: 10,
    smartkassa_cost: 3100,
    web_kassa_cost: 1200,
  }, */
]

@connect(
  (state) => ({
    payment: state.payment,
  }),
  (dispatch) => ({
    getGroups: () => dispatch(getGroups()),
    getTariffs: (id) => dispatch(getTariffs(id)),
    getAllTariffs: () => dispatch(getAllTariffs()),
    payTariff: (id, psCode) => dispatch(payTariff(id, psCode)),
  }),
)
@withTranslation()
class PaymentPage extends Component {
  state = {
    pay: [],
    modalState: false,
    payFew: false,
    groups: this.props.payment.groups,
    tariffs: this.props.payment.tariffs,
    loader: true,
  }
  getCashbox = () => data

  componentDidMount() {
    this.props.getGroups()
  }

  componentDidUpdate() {
    if (this.props.payment.groups.length > this.state.groups.length) {
      this.props.getAllTariffs()
      this.setState({ groups: this.props.payment.groups })
    } else if (this.props.payment.tariffs.length > this.state.tariffs.length) {
      this.setState({ tariffs: this.props.payment.tariffs })
    }
    if (this.props.payment.url) {
      document.location.href = this.props.payment.url
    }
  }

  addToPay = (el) => {
    const pay = this.state.pay
    pay.push(el)
    this.setState({ pay: pay })
  }

  deletePay = (el) => {
    const pay = this.state.pay.filter((q) => q !== el)
    this.setState({ pay: pay })
  }

  payFunction = () => {
    this.setState({ modalState: true })
  }

  closeFunction = () => {
    this.setState({ modalState: false, pay: [] })
    this.setState({ added: false })
  }

  render() {
    const { t } = this.props
    return (
      <div>
        {this.state.tariffs.length < 1 && (
          <Loader
            active
            style={{
              marginTop: 50,
            }}
          />
        )}
        {/*
        <div className="payment-button-container">
          {this.state.payFew ? (
            <div>
              <Button
                onClick={() => {
                  this.setState({ payFew: false, pay: [] })
                }}
              >
                {t("cancel")}
              </Button>
              <Button
                color="green"
                onClick={() => {
                  this.setState({ payFew: false })
                  this.payFunction()
                }}
              >
                {t("pay")}
              </Button>
            </div>
          ) : (
            <div>
              <Button
                color="green"
                onClick={() => {
                  data.map((el) => {
                    this.addToPay(el)
                  })
                  this.payFunction()
                }}
              >
                {t("payAll")}
              </Button>
              <Button
                color="green"
                onClick={() => {
                  this.setState({ payFew: true })
                }}
              >
                {t("payAFew")}
              </Button>
            </div>
          )}
        </div>
              */}
        <Card.Group className="payment-cashbox-container">
          {/* this.getCashbox().map((el) => {
            return (
              <>
                <CashboxComponent
                  name={el["name"]}
                  physicalization={el["physicalization"]}
                  endDate={new Date(el["endDate"])}
                  addToPay={this.addToPay}
                  el={el}
                  payFunction={this.payFunction}
                  payFew={this.state.payFew}
                  deletePay={this.deletePay}
                  added={
                    this.state.pay.filter((q) => q["name"] === el["name"])
                      .length > 0
                  }
                />
              </>
            )
          }) */}
          {this.state.tariffs.map((el) => {
            return (
              <Card>
                <Card.Content className="payment-page-card">
                  <div>
                    <Card.Header>{el["Tariff"]}</Card.Header>
                    <Card.Description>
                      {t("price") + ": " + el["Sum"]}
                    </Card.Description>
                    <Card.Description>
                      {t("description") + ": " + el["Descr"]}
                    </Card.Description>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      style={{ marginTop: 10 }}
                      onClick={() => {
                        this.props.payTariff(el["ID"], "bcc")
                      }}
                    >
                      {t("pay")}
                    </Button>
                  </div>
                </Card.Content>
              </Card>
            )
          })}
        </Card.Group>
        <Modal
          open={this.state.modalState}
          onClose={this.closeFunction}
          centered={false}
          className="payment-modal"
        >
          <Modal.Content>
            <PaymentComponent
              toPay={this.state.pay}
              closeFunction={this.closeFunction}
            />
          </Modal.Content>
        </Modal>
      </div>
    )
  }
}

export default withRouter(PaymentPage)
